import React from 'react';
import { useNavigate } from 'react-router-dom';
import QuickCaptureWidget from '../components/QuickCaptureWidget';
import toast from 'react-hot-toast';

/**
 * ReportIssue — Patient quick-capture symptom form page.
 */
const ReportIssue = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6 py-6">
      <QuickCaptureWidget
        onEventCreated={() => {
          toast.success('Report submitted successfully');
          navigate('/my-health');
        }}
      />
    </div>
  );
};

export default ReportIssue;
